import { getCoreDataSecurityActionPlanSlice } from './get';

export const { requestGetCoreDataSecurityActionPlan, resetGetCoreDataSecurityActionPlan } =
    getCoreDataSecurityActionPlanSlice.asyncActionCreators;
